export default __webpack_public_path__ + "static/media/DNo.20-9.3e7f1d61.jpg";